export const environmentName = process.env.REACT_APP_ENV?.toLowerCase()

export const isDevelopment = (() => {
    if (!environmentName) {
        return false
    }

    return ['localhost', 'dev'].includes(environmentName)
})()
